import { IRevenueScheduleSummary } from '@monetize/types/app';
import { FC } from 'react';
import { useGetRevenueScheduleSubscriptionItems } from '../../api/revenueService';
import { MPageLoader } from '../Monetize';
import { RevenueScheduleTable } from './RevenueScheduleTable';
import { useRevenueSchedulePeriodsInfinite } from './useRevenueSchedulePeriodsInfinite';

interface ScheduleVersionPeriodsTableProps {
  schedule: IRevenueScheduleSummary;
}

export const ScheduleVersionPeriodsTable: FC<
  ScheduleVersionPeriodsTableProps
> = ({ schedule }) => {
  const contractStart = schedule.contractData?.term?.start ?? null;
  const contractEndInclusive =
    schedule.contractData?.term?.endInclusive ?? null;

  const {
    periods,
    loadedThrough,
    isInitialLoading,
    isFetchingMore,
    loadNextWindow,
  } = useRevenueSchedulePeriodsInfinite({
    scheduleId: schedule.id,
    contractStart,
    contractEndInclusive,
  });

  const { data: subscriptionItems } = useGetRevenueScheduleSubscriptionItems(
    schedule.id,
  );

  if (isInitialLoading) {
    return <MPageLoader height="auto" />;
  }

  return (
    <RevenueScheduleTable
      subscriptionItems={subscriptionItems ?? []}
      periods={periods}
      contractStart={contractStart}
      contractEndInclusive={contractEndInclusive}
      loadedThrough={loadedThrough}
      isLoadingMore={isFetchingMore}
      onLoadMore={loadNextWindow}
    />
  );
};
